var _defs, _path, _path2, _path3, _path4, _g, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "inset-shadow"
  }, /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "SourceAlpha"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "table",
    tableValues: "1 0"
  })), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 6,
    result: "offsetblur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(0, 0, 0, 0.9)",
    result: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "offsetblur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }), /*#__PURE__*/React.createElement("feMergeNode", null))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M407,0v30h60c8.3,0,15,6.7,15,15v60h30V15c0-8.3-6.7-15-15-15H407z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45,30h60V0H15C6.7,0,0,6.7,0,15v90h30V45C30,36.7,36.7,30,45,30z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M467,482h-60v30h90c8.3,0,15-6.7,15-15v-90h-30v60C482,475.3,475.3,482,467,482z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30,407H0v90c0,8.3,6.7,15,15,15h90v-30H45c-8.3,0-15-6.7-15-15V407z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M201.3,54.4H69.7c-8.3,0-15,6.7-15,15V186c0,8.3,6.7,15,15,15h116.6c8.3,0,15-6.7,15-15L201.3,54.4L201.3,54.4z M171.3,171 H84.7V84.4h86.6L171.3,171L171.3,171z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.3,104h17.4c8.3,0,15,6.7,15,15v17.4c0,8.3-6.7,15-15,15h-17.4c-8.3,0-15-6.7-15-15V119C104.3,110.7,111,104,119.3,104 z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M442.3,311H310.6v124.8h-15.4V297.6h73.6V173.2h-24.5v-48.7h-27.8V85.3h-21.8v39.2h-27.8v48.7h-24.5v262.6h-14.8V221.9 h-95.1v213.9H54.7v21.8h270c0.3,0,0.7,0.1,1,0.1h116.6c0.3,0,0.7,0,1-0.1h3.8v-0.7c6-2,10.2-7.6,10.2-14.2V326 C457.2,317.8,450.5,311,442.3,311z M319,200.1h21.8v21.8H319V200.1z M319,248.9h21.8v21.8H319V248.9z M190.4,427.2h-21.8v-21.8h21.8 V427.2z M190.4,375h-21.8v-21.8h21.8V375z M190.4,322.9h-21.8V301h21.8V322.9z M190.4,270.7h-21.8v-21.8h21.8V270.7z M294.7,151.4 h21.8v21.8h-21.8V151.4z M292.1,270.7h-21.8v-21.8h21.8V270.7z M292.1,221.9h-21.8v-21.8h21.8V221.9z M340.6,341h86.6v86.6h-86.6 V341z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M375.2,360.6h17.4c8.3,0,15,6.7,15,15V393c0,8.3-6.7,15-15,15h-17.4c-8.3,0-15-6.7-15-15v-17.4 C360.2,367.3,366.9,360.6,375.2,360.6z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.303fc731.svg";
export { ForwardRef as ReactComponent };